import React, { useEffect, useState } from 'react';
import useRenderComponents from 'src/hooks/useRenderComponents';
import { ErrorBoundary } from 'react-error-boundary';
import GeneratePortals from 'src/components/RenderViewFromTemplate/GeneratePortals';

interface IProps {
	templateProxy: string;
	viewProxy: {[key: string]: any };
}

const RenderViewFromTemplate = ({ templateProxy, viewProxy, }: IProps) => {
	const [ view, setView, ] = useState<{[key: string]: any }>({});

	const randomNumber = Math.floor(Math.random() * 100);
	const [ templateData, setTemplateData, ] = useState('');

	const { components, html, } = useRenderComponents({
		template: templateData,
		view,
	});

  
	useEffect(() => {
		setView(viewProxy);
	}, [ viewProxy, ]);

	useEffect(() => {
		setTemplateData(templateProxy);
	}, [ templateProxy, ]);
   

	return (
		<ErrorBoundary FallbackComponent={() => <></>}>
			<div
				dangerouslySetInnerHTML={{ __html: html, }}
				style={{
					flex: 1,
					height: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
				}}
				id={`container_${randomNumber}`}
			></div>
			<GeneratePortals components={components} />
		</ErrorBoundary>
	);
};

export default RenderViewFromTemplate;